exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2LM5y{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2LM5y:first-child{margin-right:20px}.f6hfQ{margin:0 20px 0 0;font-size:20px}._2UXEW,.f6hfQ{font-weight:600}._2UXEW{margin-right:20px;font-size:36px}._2MW_t{height:0;border:1px solid #c4c4c4;-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%}._3gcMz{margin-right:20px}", ""]);

// exports
exports.locals = {
	"root": "_2LM5y",
	"title": "f6hfQ",
	"h1": "_2UXEW",
	"divider": "_2MW_t",
	"dividerLeft": "_3gcMz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/TitleDivider/TitleDivider.css
// module id = 3266
// module chunks = 21